import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseRestApiService } from 'src/app/service/baseRestApiService.service';
import { UrlProviderService, EndPoints } from 'src/app/service/urlprovider.service';

@Injectable({
    providedIn: 'root'
})
export class CalpadSSIDResoultion extends BaseRestApiService {
    constructor(http: HttpClient, urlProvider: UrlProviderService) {
        super(http, urlProvider);
    }

    getOverallCounts(): Observable<any> {
        return this.get<any>(EndPoints.get_CalpadSSIDResolution_OverallCounts, undefined, '');
    }
    getUnresolvedCounts(regionCode: string) {
        return this.get<any>(
            EndPoints.get_CalpadSSIDResolution_UnresolvedCounts, undefined, 
            `${regionCode}`);
    }
    getResolvedCounts(regionCode: string, startDate?: string, endDate?: string, resolve?: string) {
        return this.get<any>(
            EndPoints.get_CalpadSSIDResolution_ResolvedCounts, undefined,
            `?regionCode=${regionCode}&startDate=${startDate}&endDate=${endDate}&systemResolve=${resolve}`
        );
    }
    getStudentInfo(studentId: string) {
        return this.get<any>(
            EndPoints.get_CalpadSSIDResolution_StudentInfo, undefined,
            `?id=${studentId}`
        );
    }
    getResolvedStudent(studentId: string) {
        return this.get<any>(
            EndPoints.get_CalpadSSIDResolution_StudentInfo, undefined,
            `?id=${studentId}`
        );
    }
    getResolvedStudentAll(studentId: string) {
        return this.get<any>(
            EndPoints.get_CalpadSSIDResolution_ResolvedStudent, undefined,
            `?id=${studentId}`
        );
    } 
    GetUnresolvedStudent(studentId: string) {
        return this.get<any>(
            EndPoints.get_CalpadSSIDResolution_UnresolvedStudent, undefined,
            `?id=${studentId}`
        );
    }     
    
    resolveSSID(studentId: string, calpadStudentId: string, calpadStudentIndexId: string, ssid: string  ) {
        return this.post<any>(EndPoints.post_calpadSSIDResolution,false,'',{            
            studentId: studentId,
            calpadsStudentId: calpadStudentId,
            calpadsStudentIndexId: calpadStudentIndexId,
            ssid: ssid
            });
    }
    resolveNoMatch(studentId: string, calpadStudentId: string   ) {
        return this.post<any>(EndPoints.post_calpadSSIDNoMatch,false,'',{            
            studentId: studentId,
            calpadsStudentId: calpadStudentId,
            calpadsStudentIndexId: 0,
            ssid: 0
            });
    }
     
    getPreviousSSID(studentId: string) {
        return this.get<any>(
            EndPoints.get_CalpadSSIDResolution_PreviousSSID, undefined,
            `?id=${studentId}`
        );
    } 

    getHistoryAll(studentId: number) {
        return this.get<any>(EndPoints.calpadsSsidResolutions_GetHistoryAll, undefined, `${studentId}`);
    }
}
